import { Component, ViewChild, OnInit, AfterViewInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTabChangeEvent, MatTabGroup } from '@angular/material/tabs';
import { ActivatedRoute, Router } from '@angular/router';
import { VideoPlayerComponent } from 'src/app/components/video-player/video-player.component';
import { VideoStoreAccessLog, VideoStoreAccessLogDefaultValues } from 'src/app/components/video-store/video-store-access-log';
import { AuthService } from 'src/app/services/auth.service';
import { TranslationService } from 'src/app/services/translation.service';
import { VideoStoreService } from 'src/app/services/video-store.service';



@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    standalone: false
})
export class DashboardComponent implements OnInit {

	selectedTab: number=0;
	rolename:string=''
	videoList:any[]=[]
	videoAccessLog:VideoStoreAccessLog=VideoStoreAccessLogDefaultValues()
	translation:any
	programPacks:any[]=[]
	constructor(private _authservice: AuthService,private route:ActivatedRoute,private router:Router,private videoservice:VideoStoreService,private dialog: MatDialog,
		private translationservice:TranslationService
	) { }

  ngOnInit(): void {
	this.videoservice.getVideosByLanguage().subscribe({
		next: (response) => {
			this.videoList = response
		}
	})

	this.translationservice.getTranslation().subscribe({
		next: (response) => {
			this.translation = response
		}
	})

	this.videoservice.getAllProgramPacksByLanguage().subscribe({
		next: (response) => {this.programPacks = response}
	})

  }

  openVideoPlayer(vimeoVideoId:string,title:string,id:number)
  {	
	this.videoAccessLog.videoId = id
	this.videoservice.logAccessForVideos(this.videoAccessLog).subscribe({
		next: (response) => {
			console.log(response)
		}
	})
	const dialogRef = this.dialog.open(VideoPlayerComponent, {
		data: { vimeoVideoId: vimeoVideoId,title:title},
		panelClass:'video-player-modal',
		width: 'min(1280px, 98vw)',
		maxWidth: '98vw',
		maxHeight: 'calc(100dvh - 16px)'
	  });

  }

 
}
